import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Committees } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const FlashProfileDialog = ({ open, onOpenChange, onSaved }) => {
  const [v, setV] = useState({ facility_name: "", facility_address: "" });
  useEffect(() => {
    if (open) Committees.getFacility().then((f) => setV({ facility_name: f.facility_name || "", facility_address: f.facility_address || "" }));
  }, [open]);
  const save = async () => {
    try {
      await Committees.updateFacility(v);
      toast.success("Hospital profile saved");
      onSaved();
      onOpenChange(false);
    } catch {
      toast.error("Could not save profile");
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-white" data-testid="flash-profile-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Hospital profile</DialogTitle>
          <DialogDescription>Shown on the flash page and on every PDF (also used on committee packets).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Hospital name</Label>
            <Input value={v.facility_name} onChange={(e) => setV({ ...v, facility_name: e.target.value })} data-testid="profile-facility-name" />
          </div>
          <div className="space-y-1.5">
            <Label>Address (optional)</Label>
            <Input value={v.facility_address} onChange={(e) => setV({ ...v, facility_address: e.target.value })} data-testid="profile-facility-address" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={save} className="bg-[#0284c7] hover:bg-[#0369a1]" data-testid="profile-save">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
